import styled from "styled-components";

export const GameBadgeFlippeInner= styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    transition: transform 0.8s;
    transform-style: preserve-3d;

    animation: flip 5s ease-in-out infinite;
    animation-direction: alternate;

    @keyframes flip {
        0% { transform: rotateY(0deg); }
        45% { transform: rotateY(0deg); }
        50% { transform: rotateY(180deg); }
        100% { transform: rotateY(180deg); }
    }
`;
